import { useState, useEffect, useContext, useCallback } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useInsights = () => {
  const { baseUrl, basicAuth, userID } = useContext(GlobalContext);

  const [insights, setInsights] = useState({});
  const [loading, setLoading] = useState(false);

  const postRequest = useCallback(async (endpoint, body) => {
    if (!baseUrl || !basicAuth) return null;

    try {
      const res = await fetch(`${baseUrl}${endpoint}`, {
        method: "POST",
        headers: {
          Authorization: basicAuth,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      return await res.json();
    } catch (err) {
      console.error("Insights API Error:", err);
      return null;
    }
  }, [baseUrl, basicAuth]);

  const fetchInsights = useCallback(async () => {
    if (!userID) return;

    try {
      setLoading(true);

      const data = await postRequest(
        "/Whatsapp/whatsappInsights",
        {
          userid: userID,
          secret: "string",
          fromDate: "string",
          toDate: "string",
        }
      );

      if (data?.responseCode === "00") {
        setInsights(data?.data || {});
      } else {
        setInsights({});
      }
    } finally {
      setLoading(false);
    }
  }, [userID, postRequest]);

  useEffect(() => {
    fetchInsights();
  }, [fetchInsights]);

  return { insights, loading, fetchInsights };
};

export default useInsights;